/**
 * countryDialCodes — the fixed country list for the phone country-code
 * picker (Figma's "Dropdown / Country code": India, UAE, Singapore, UK, US
 * — search-filterable, India selected by default). Matches Figma's shown
 * set exactly rather than a full ISO-3166 list neither Figma nor any
 * existing part of this codebase specifies; extending it later is a content
 * change, not a rebuild — see the CreatorProfileDrawer task report.
 */
export interface CountryDialCode {
  /** ISO 3166-1 alpha-2, for `CountryFlag`. */
  code: string;
  name: string;
  dialCode: string;
}

export const COUNTRY_DIAL_CODES: CountryDialCode[] = [
  { code: 'IN', name: 'India', dialCode: '+91' },
  { code: 'AE', name: 'United Arab Emirates', dialCode: '+971' },
  { code: 'SG', name: 'Singapore', dialCode: '+65' },
  { code: 'GB', name: 'United Kingdom', dialCode: '+44' },
  { code: 'US', name: 'United States', dialCode: '+1' },
];

/** India — Figma's default selection for the country-code picker. */
export const DEFAULT_COUNTRY_DIAL_CODE = '+91';
